const englishTranslations = {
  todaySection: {
    HOME: {
      "top-heading": "Welcome",
      message1: `Now please tell us--about your health details`,
      message2: "This will take 10-15 minutes.",
      health: "Health Information",
      start: "Start",
      pending: "Pending",
      update: "Update",
      complete: "Complete",
      sessionTodayMsg1: "Today at ",
      sessionTodayMsg2: "You have a session with",
      session: "Your session with",
      dAkerkar: "Dr. Akerkar",
      at: "at",
      today: "today.",
      clinic0: "Online",
      clinic1: "Bhandup",
      clinic2: "Kalyan",
      clinic3: "Dombivali",
      clinic4: "Badlapur",
      clinic5: "Malad",
      clinic6: "Thane",
      appointment1: "Please arrive 30 minutes",
      appointment2: "prior to your appointment.",
      working1: "We are working on the app",
      working2: "to provide you",
      working3: "better care and",
      working4: "improve your experience.",
      working5: "In the future, you will see",
      working6: "your diet plans and physio plans",
      working7: "on this screen",
    },
  },
  introPage: {
    INTRO: {
      page1: {
        today: "Today",
        organise: "Organise your day in one place.",
        skip: "SKIP",
      },
      page2: {
        health: "My Health",
        clinical:
          "Your health and clinical information, such as Health Info, Prescriptions and Test Reports.",
      },
      page3: {
        clinic1: "My Clinic",
        clinic2:
          "Your interactions with the clinic, such as Appointments, Messages and Payments.",
      },
      page4: {
        menu: "Menu",
        personal:
          " Your personal, privacy and app setting such as Profile, Setting, About us and Privacy and Security.",
      },
      page5: {
        library: "Library",
        videos: "All informative videos and posts related to Arthritis.",
        done: "DONE",
      },
    },
  },
  MYHEALTH: {
    care: "Integrated Care",
    prescription: "Prescription",
    test: "Tests/Reports",
    reports: "Reports",
    diet: "Diet",
    physio: "Physio",
    pain: "Pain Score",
    info: "Health Info",
    chart: "Charts",
  },
};

const marathiTranslations = {
  todaySection: {
    HOME: {
      "top-heading": "स्वागत आहे",
      message1: "आता कृपया--आम्हाला तुमच्या आरोग्याबद्दल माहिती सांगा",
      message2: "यास 10-15 मिनिटे लागतील.",
      health: "आरोग्य माहिती",
      start: "सुरुवात करा",
      pending: "अपूर्ण आहे",
      update: "अपडेट करा",
      complete: "पूर्ण झाली",
      sessionTodayMsg1: "आज ",
      sessionTodayMsg3: " वाजता",
      sessionTodayMsg2: "यांच्यासोबत तुमचे सत्र आहे.",
      session: "आज तुमचे",
      dAkerkar: "डॉ. आकेरकर यांच्यासोबत",
      at: "",
      today: "सत्र होईल",
      clinic0: "ऑनलाइन",
      clinic1: "भांडुप",
      clinic2: "कल्याण",
      clinic3: "डोंबिवली",
      clinic4: "बदलापूर",
      clinic5: "मलाड",
      clinic6: "ठाणे",
      appointment1: "कृपया तुमच्या अपॉइंटमेंटच्या",
      appointment2: "30 मिनिटे अगोदर या",
      working1: "तुम्हाला अधिक चांगली",
      working2: "काळजी देण्यासाठी आणि",
      working3: "तुमचा अनुभव सुधारण्यासाठी",
      working4: "आम्ही अँपवर काम करत आहोत",
      working5: "In the future, you will see",
      working6: "your diet plans and physio plans",
      working7: "on this screen",
    },
  },
  introPage: {
    INTRO: {
      page1: {
        today: "आज",
        organise: "तुमचा दिवस एका पानावर आयोजित करा.",
        skip: "वगळा",
      },
      page2: {
        health: "माझे आरोग्य",
        clinical:
          "तुमचे आरोग्य आणि वैद्यकीय माहिती जसे की आरोग्य माहिती, प्रिस्क्रिप्शन आणि चाचणी अहवाल",
      },
      page3: {
        clinic1: "माझे क्लिनिक",
        clinic2: "तुमचा क्लिनिकशी संवाद जसे की भेटी, संदेश आणि पेमेंट",
      },
      page4: {
        menu: "मेनू",
        personal:
          "तुमची वैयक्तिक, गोपनीयता आणि अँप सेटिंग्ज जसे की प्रोफाइल सेटिंग्ज, आमच्याबद्दल आणि गोपनीयता आणि सुरक्षितता",
      },
      page5: {
        library: "लायब्ररी",
        videos: "संधिवात संबंधित सर्व माहितीपूर्ण पोस्ट आणि व्हिडिओ",
        done: "पूर्ण झ्हाले",
      },
    },
  },
  MYHEALTH: {
    care: "एकात्मिक काळजी",
    prescription: "प्रिस्क्रिप्शन",
    test: "चाचण्या/अहवाल",
    reports: "अहवाल",
    diet: "आहार",
    physio: "फ़िजिओथेरपी",
    pain: "वेदना गुण",
    info: "आरोग्य माहिती",
    chart: "चार्ट",
  },
};

const hindiTranslations = {
  todaySection: {
    HOME: {
      "top-heading": "स्वागत हैं",
      message1: "अब कृपया हमें--अपने स्वास्थ्य के बारे में बताएं",
      message2: " इसमें 10-15 मिनट का समय लगेगा।",
      health: "स्वास्थ्य की जानकारी",
      start: "शुरू करें",
      pending: "अधूरा हैं",
      update: "अपडेट करें",
      complete: "पूर्ण हो गई हैं",
      sessionTodayMsg1: "आज ",
      sessionTodayMsg3: " बजे",
      sessionTodayMsg2: "के साथ आपका एक सत्र हैं।",
      session: "आज आपका",
      dAkerkar: "डॉ.अकरकर के साथ",
      at: "",
      today: "एक सत्र होगा|",
      clinic0: "ऑनलाइन",
      clinic1: "भांडुप",
      clinic2: "कल्याण",
      clinic3: "डोंबिवली",
      clinic4: "बदलापूर",
      clinic5: "मलाड",
      clinic6: "ठाणे",
      appointment1: "कृपया अपनी अपॉइंटमेंट",
      appointment2: "से 30 मिनट पहले पहुंचें",
      working1: "आपको बेहतर देखभाल",
      working2: "प्रदान करने और आपके",
      working3: "अनुभव को बेहतर बनाने",
      working4: "के लिए हम ऐप पर काम कर रहे हैं|",
      working5: "In the future, you will see",
      working6: "your diet plans and physio plans",
      working7: "on this screen",
    },
  },
  introPage: {
    INTRO: {
      page1: {
        today: "आज",
        organise: "अपने दिन को 1 पेज में आयोजित करें",
        skip: "स्किप करें",
      },
      page2: {
        health: "मेरा स्वास्थ्य",
        clinical:
          "आपका स्वास्थ्य और क्लीनिकल ​​जानकारी जैसे स्वास्थ्य जानकारी, प्रेस्क्रिप्शन और परीक्षण रिपोर्ट्स",
      },
      page3: {
        clinic1: "मेरा क्लिनिक",
        clinic2: "क्लिनिक के साथ आपकी लेनदेन जैसे अपॉइंटमेंट, संदेश और भुगतान",
      },
      page4: {
        menu: "मेनू",
        personal:
          "आपकी व्यक्तिगत, गोपनीयता और ऐप सेटिंग्स जैसे प्रोफ़ाइल सेटिंग्स, हमारे बारे में, और गोपनीयता और सुरक्षा",
      },
      page5: {
        library: "लायब्ररी",
        videos: "गठिया से संबंधित सभी सूचनात्मक पोस्ट और वीडियो",
        done: "समाप्त",
      },
    },
  },
  MYHEALTH: {
    care: "एकीकृत देखभाल",
    prescription: "प्रिस्क्रिप्शन",
    test: "टेस्ट/रिपोर्ट",
    reports: "रिपोर्ट",
    diet: "डाइट",
    physio: "फ़िजिओथेरपी",
    pain: "पेन स्कोर",
    info: "स्वास्थ्य की जानकारी",
    chart: "चार्ट",
  },
};

export const translations = {
  EN: englishTranslations,
  MR: marathiTranslations,
  HI: hindiTranslations,
};
